import graphql__bc25d5fc328868abfb35 from "./__generated__/MapEventMarkersManagerQuery.graphql.js";import { graphql } from "react-relay";

import AppQueryRenderer from "../../AppQueryRenderer";
import MapEventMarkers from "./MapEventMarkers";

const MapEventMarkersManager = ({ mapId }) => {
  return (
    <AppQueryRenderer
      key={mapId}
      query={MapEventMarkersManagerQuery}
      variables={{ mapId }}
      component={MapEventMarkers}
    />
  );
};

export default MapEventMarkersManager;

const MapEventMarkersManagerQuery = graphql__bc25d5fc328868abfb35;
